module.exports = __webpack_public_path__ + "media/images/black_history_month/okra_stew-f5cee76a42428589f6f0911c0e596bd6.png";